import React, { Component } from 'react';

import Helmet from './Helmet';

const Image = 'https://canny.io/images/canny-social.png';
const Title = 'Get a free Canny account';
const Description = 'Easily gather, track, and manage user feedback';
export default class RegisterHelmet extends Component {
  render() {
    return (
      <Helmet
        title="Canny"
        meta={[
          { name: 'robots', content: 'noindex,follow' },

          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/register' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
